import { tuple } from './type';
export var PresetColorTypes = tuple('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');
//# sourceMappingURL=colors.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/colors.js
// module id = 306
// module chunks = 3